var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vuedraggable',{attrs:{"group":_vm.config.id},on:{"change":_vm.config.change,"start":function($event){_vm.drag=true},"end":function($event){_vm.drag=false}},model:{value:(_vm.config.array),callback:function ($$v) {_vm.$set(_vm.config, "array", $$v)},expression:"config.array"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }